import React from 'react';
import TimelineNotification from './TimelineNotification';
import LaboratoryNotification from './laboratory/LaboratoryNotification';
import ReferralNotification from './ReferralNotification';
import {
  TYPE_COXA_TREATMENT_PERIOD,
  TYPE_DEFAULT,
  TYPE_FIMLAB,
  TYPE_GTI,
  TYPE_HEARING_DEVICE_FIXING,
  TYPE_HEARING_DEVICE_MODELING,
  TYPE_SLEEP_CLINIC,
  TYPE_REFERRAL,
  TYPE_VIDEO_CONFERENCE,
} from '../../../definitions/TimelineItems';
import Loader from '../../../components/Loader';
import { isRemoteVisit, isPhoneVisit } from '../../../utils/TimelineUtils';

const EventNotifications = ({
  isFetching,
  notifications,
  approveTimelineEvent,
  setReferralNotified,
  showRescheduleTransitionModal,
  navigateToReschedule,
  history,
  linkkipalvelu,
  qIsFetching,
}) => {
  if (isFetching) {
    return <Loader />;
  }

  function determineImagingNotificationDescription(subtype) {
    // Dirty but takes e.g. TYPE_IMAGING_TOMOGRAPHY and returns only the last part like TOMOGRAPHY
    let type = subtype.toString().split('_').slice(-1).pop();
    if (type) {
      return 'timelinenotification.description.imaging.' + type;
    }
    return 'timelinenotification.description.default';
  }

  const notificationElements = notifications.map((notification, index) => {
    if (notification?.config?.type === 'imaging') {
      return (
        <TimelineNotification
          key={notification.id}
          data={notification}
          qIsFetching={qIsFetching}
          description={determineImagingNotificationDescription(
            notification?.config?.subtype
          )}
          approveTimelineReservation={() =>
            approveTimelineEvent(notification.id)
          }
          canBeRescheduled={notification.canBeRescheduled}
          linkkipalvelu={linkkipalvelu}
          rescheduleTimelineReservation={() => {
            if (notification.canBeRescheduled === 'CAN_RESCHEDULE_ONCE') {
              showRescheduleTransitionModal(notification.id);
            } else if (
              notification.canBeRescheduled === 'CAN_RESCHEDULE_MULTIPLE'
            ) {
              navigateToReschedule(notification.id, history);
            }
          }}
        />
      );
    } else if (notification?.config?.type === 'hospitalWard') {
      return (
        <TimelineNotification
          key={notification.id}
          data={notification}
          description={'hospitalward.notification.message'}
          approveTimelineReservation={() =>
            approveTimelineEvent(notification.id)
          }
          linkkipalvelu={linkkipalvelu}
        />
      );
    }
    switch (notification.type) {
      case TYPE_GTI:
      case TYPE_DEFAULT:
      case TYPE_HEARING_DEVICE_MODELING:
      case TYPE_HEARING_DEVICE_FIXING:
      case TYPE_SLEEP_CLINIC:
      case TYPE_COXA_TREATMENT_PERIOD: {
        const description = descriptionByType(notification);

        return (
          <TimelineNotification
            key={notification.id}
            data={notification}
            qIsFetching={qIsFetching}
            description={description}
            approveTimelineReservation={() =>
              approveTimelineEvent(notification.id)
            }
            canBeRescheduled={notification.canBeRescheduled}
            linkkipalvelu={linkkipalvelu}
            rescheduleTimelineReservation={() => {
              if (notification.canBeRescheduled === 'CAN_RESCHEDULE_ONCE') {
                showRescheduleTransitionModal(notification.id);
              } else if (
                notification.canBeRescheduled === 'CAN_RESCHEDULE_MULTIPLE'
              ) {
                navigateToReschedule(notification.id, history);
              }
            }}
          />
        );
      }
      case TYPE_FIMLAB: {
        return (
          <LaboratoryNotification key={notification.id} data={notification} />
        );
      }
      case TYPE_REFERRAL: {
        return (
          <ReferralNotification
            key={notification.id}
            data={notification}
            setReferralNotified={() => setReferralNotified(notification.id)}
          />
        );
      }
      case TYPE_VIDEO_CONFERENCE: {
        const description = descriptionByType(notification);

        return (
          <TimelineNotification
            key={notification.id}
            data={notification}
            qIsFetching={qIsFetching}
            description={description}
            approveTimelineReservation={() =>
              approveTimelineEvent(notification.id)
            }
            canBeRescheduled={notification.canBeRescheduled}
            linkkipalvelu={linkkipalvelu}
            rescheduleTimelineReservation={() => {
              if (notification.canBeRescheduled === 'CAN_RESCHEDULE_ONCE') {
                showRescheduleTransitionModal(notification.id);
              } else if (
                notification.canBeRescheduled === 'CAN_RESCHEDULE_MULTIPLE'
              ) {
                navigateToReschedule(notification.id, history);
              }
            }}
          />
        );
      }
    }
  });
  return <div>{notificationElements}</div>;
};

const descriptionByType = (notification) => {
  if (isRemoteVisit(notification)) {
    return 'timelinenotification.description.remote';
  } else if (isPhoneVisit(notification)) {
    return 'timelinenotification.description.phone';
  } else if (notification.type === TYPE_COXA_TREATMENT_PERIOD) {
    return 'timelinenotification.description.treatmentperiod';
  } else {
    return 'timelinenotification.description.default';
  }
};

export default EventNotifications;
